import styled from 'styled-components'

import LeftBar from '../home/components/leftBar'
import Suport from './suport'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function SuportForm() {
    return (
        <Page>
            <LeftBar />
            <Suport />
        </Page>
    )
}
